// Shared AI fit-ranking color/label config used by the Sentinel feeds
// (SAM, eBuy, HigherGov). Single source of truth — see RankBadge.jsx for
// the shared rendering component that consumes this.
export const AI_RANK_CONFIG = {
  BLUE:   { label: 'Blue',   cls: 'bg-blue-600 text-white',   dot: 'bg-blue-600',   tip: '≥50% requirements met — strong fit'  },
  GREEN:  { label: 'Green',  cls: 'bg-green-600 text-white',  dot: 'bg-green-600',  tip: '≥40% requirements met — good fit'    },
  YELLOW: { label: 'Yellow', cls: 'bg-yellow-500 text-white', dot: 'bg-yellow-500', tip: '≥30% requirements met — moderate fit'},
  RED:    { label: 'Red',    cls: 'bg-red-600 text-white',    dot: 'bg-red-600',    tip: '≥20% requirements met — weak fit'    },
  GRAY:   { label: 'Gray',   cls: 'bg-slate-400 text-white',  dot: 'bg-slate-400',  tip: '<20% requirements met — poor fit'    },
};

// Ascending "best fit first" sort order for the AI Fit column, so sorting
// follows the actual fit-quality scale instead of an ASCII sort on the
// color name. Unranked opportunities (no ai_rank yet) sort last.
export const AI_RANK_ORDER = { BLUE: 0, GREEN: 1, YELLOW: 2, RED: 3, GRAY: 4 };
